export function isValidCompareTab(value = ''): boolean {
  return (
    value === 'table' || value === 'leaderboard' || value === 'dashboard' || value === 'charts'
  );
}
